import demo from './demo-routes'

export default [
  // - Dashboard
  {
    name: 'dashboard',
    path: '',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/index')), 'dashboard')
  },
  {
    name: 'update',
    path: 'update',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/update')), 'update')
  },
  {
    name: 'about',
    path: 'about',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/about')), 'about')
  },
  {
    name: 'profile',
    path: 'profile',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/profile')), 'users')
  },
  {
    name: 'management',
    path: 'management',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/management')), 'management')
  },
  // 设备平台
  {
    name: 'equipment',
    path: 'equipment',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/equipment')), 'equipment')
  },
  {
    name: 'deviceschart',
    path: 'devices/chart/:serial',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/devicechart')), 'deviceschart')
  },
  {
    name: 'channelschart',
    path: 'channels/chart/:serial',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/channelschart')), 'channelschart')
  },
  {
    name: 'devicesgps',
    path: 'devices/gps/:serial',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/devicegps')), 'devicesgps')
  },
  {
    name: 'sgmanage',
    path: 'sgmanage',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/sgmanage')), 'sgmanage')
  },
  {
    name: 'new',
    path: 'new/:type',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/new')), 'posts')
  },
  {
    name: 'edit',
    path: 'edit/:type/:slug?',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/edit')), 'posts')
  },
  // - Media
  {
    name: 'alerts',
    path: 'alerts',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/alerts')), 'alerts')
  },
  {
    name: 'upload',
    path: 'upload',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/upload')), 'upload')
  },
  // - Users
  {
    name: 'users',
    path: 'users/:page?',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/users')), 'users')
  },
  {
    name: 'roles',
    path: 'roles',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/roles')), 'users')
  },
  {
    name: 'permissions',
    path: 'permissions',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/permissions')), 'users')
  },
  // - reports
  {
    name: 'reports',
    path: 'reports',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/reports')), 'reports')
  },
  {
    name: 'monthreports',
    path: 'monthreports',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/monthreports')), 'monthreports')
  },
  {
    name: 'dataexports',
    path: 'dataexports',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/dataexports')), 'dataexports')
  },
  {
    name: 'chartreport',
    path: 'chartreport',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/chartreport')), 'chartreport')
  },
  { // 科室报表
    name: 'organreport',
    path: 'organreport',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/organreport')), 'organreport')
  },
  // - Tools
  {
    name: 'install',
    path: 'install/:type',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/install')), 'plugins')
  },
  {
    name: 'import',
    path: 'import',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/import')), 'tools')
  },
  // - Options
  {
    name: 'options',
    path: 'options/:type',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/options')), 'options')
  },
  // - 报警项目
  {
    name: 'actions',
    path: 'actions',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/actions')), 'actions')
  },
  // - 报警历史
  {
    name: 'triggerinfos',
    path: 'triggerinfos',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/triggerinfos')), 'triggerinfos')
  },
  // - 用户设置
  {
    name: 'usersetting',
    path: 'usersetting',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/usersetting')), 'usersetting')
  },
  // - 组织管理
  {
    name: 'organize',
    path: 'organize',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/organize')), 'organize')
  },
  // - 修改密码
  {
    name: 'userchangepwd',
    path: 'userchangepwd',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/userchangepwd')), 'userchangepwd')
  },
  // - 过期模块
  {
    name: 'expirechannels',
    path: 'expirechannels',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/expirechannels')), 'expirechannels')
  },
  // - 日志管理
  {
    name: 'loginfo',
    path: 'loginfo',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/loginfo')), 'loginfo')
  },
  // - 授权管理
  {
    name: 'authcodeman',
    path: 'authcodeman',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/authcodeman')), 'authcodeman')
  },
  // - 异常报警设置
  {
    name: 'abnormalsetting',
    path: 'abnormalsetting',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/abnormalsetting')), 'abnormalsetting')
  },
  // - 异常报警信息
  {
    name: 'abnormalmsg',
    path: 'abnormalmsg',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/abnormalmsg')), 'abnormalmsg')
  },
  {
    name: 'icons',
    path: 'icons',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/icons')), 'icons')
  },
   // - 异常报警信息
   {
    name: 'record_history',
    path: 'record_history',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/record_history')), 'record_history')
  },
  // 开锁信息
  {
    name: 'record_history_lock',
    path: 'record_history_lock',
    meta: { requiresAuth: true },
    component: resolve => require.ensure([], () => resolve(require('views/main/record_history_lock')), 'record_history_lock')
  }
].concat(demo)

// // - Default
// {
//   name: 'default',
//   path: '',
//   meta: { requiresAuth: true },
//   redirect: { name: 'dashboard' }
// },



// WEBPACK FOOTER //
// ./src/libraries/router/main-routes.js